const encode = (value: string) => encodeURIComponent(value);

export const routes = {
  overview: '/',
  datasets: '/datasets',
  dataset: (datasetId: string) => `/datasets/${encode(datasetId)}`,
  createDataset: (search?: URLSearchParams) => withOverlay('/datasets', search, { create: '1' }),
  strategies: '/strategies',
  newStrategy: '/strategies/new',
  strategyEditor: (strategyId: string) => `/strategies/${encode(strategyId)}/edit`,
  backtests: '/backtests',
  backtest: (backtestId: string) => `/backtests/${encode(backtestId)}`,
  backtestSession: (sessionId: string) => `/backtests/session/${encode(sessionId)}`,
  createBacktest: (options: { datasetId?: string; strategyId?: string } = {}, search?: URLSearchParams) =>
    withOverlay('/backtests', search, { create: '1', ...options }),
  trading: '/trading',
  tradingConnections: '/trading/connections',
  deployment: (deploymentId: string) => `/trading/deployments/${encode(deploymentId)}`,
  createDeployment: (backtestId?: string, search?: URLSearchParams) =>
    withOverlay('/trading', search, { create: '1', backtestId }),
  myAlerts: '/settings/alerts',
  security: '/settings/security',
  users: '/admin/users',
  alertingBot: '/admin/alerting/bot',
  alertingPolicy: '/admin/alerting/policy',
  alertingDelivery: '/admin/alerting/delivery',
  logs: '/admin/logs',
  forbidden: '/forbidden',
} as const;

export const CREATE_SOURCE_PARAMS = ['create', 'datasetId', 'strategyId', 'backtestId'] as const;

export function withoutParams(search: URLSearchParams, keys: readonly string[]) {
  const next = new URLSearchParams(search);
  keys.forEach((key) => next.delete(key));
  return next;
}

function withOverlay(path: string, current: URLSearchParams | undefined, values: Record<string, string | undefined>) {
  const search = new URLSearchParams(current);
  Object.entries(values).forEach(([key, value]) => {
    if (value) search.set(key, value);
    else search.delete(key);
  });
  const query = search.toString();
  return query ? `${path}?${query}` : path;
}
